import BigNumber from 'bignumber.js';

export const roundTo = (maybeNumber: string | number, places: number = 2) => {
  if (maybeNumber === '') return '';
  if (!maybeNumber && maybeNumber !== 0) return 0;

  if (typeof maybeNumber === 'string') {
    const normalized = maybeNumber.replace(/,/, '.');
    if (normalized.endsWith('.')) return normalized;
  }

  const input =
    typeof maybeNumber === 'string'
      ? parseFloat(maybeNumber.replace(/,/, '.'))
      : maybeNumber;

  return new BigNumber(input).decimalPlaces(places).toNumber();
};
